export type ScpUploadWorklistStatusDescriptor = {
  name: string;
  value: number;
}

export class ScpUploadWorklistConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  static readonly SUW_QUEUED: number = 1;  // Must match lookup value
  static readonly SUW_COMPLETE: number = 2;  // Must match lookup value
  static readonly SUW_CANCELLED: number = 3;  // Must match lookup value

  // Sharee Roles
  static status: ScpUploadWorklistStatusDescriptor[] = [
    { name: "Unknown", value: 0 },
    { name: "Queued", value: 1 },
    { name: "Complete", value: 2 },
    { name: "Cancelled", value: 3 },

  ]


}
